// TODO - replace `document` with the scope option

const formElementValue = {
  checkbox: element =>
    Array.from(document.getElementsByName(element.name))
      .filter(c => c.checked)
      .map(c => c.value),

  'select-multiple': element =>
    Array.from(element.selectedOptions).map(o => o.value),

  default: element => element.value
};

const formValueFor = element =>
  (formElementValue[element.type] || formElementValue.default)(element);

export default track => (target, data) => {
  Object.assign(data.eventValue, {
    formElementValue: formValueFor(target)
  });
  track(data);
};
